import { format } from "date-fns";
export const fetch = async (axios, userUuid, limit, offset = 0) => {
  const resp = await axios.get(`items/${userUuid}`, {
    params: {
      limit,
      offset,
      tz: resolveTimezone()
    },
    withCredentials: true
  });
  return resp.data.data || [];
};
export const create = (axios, userUuid, items) => axios.post("/create", items.map(({
  createdAt,
  entityUuid,
  expiresAt
}) => ({
  createdAt,
  entitySubType: "article",
  entityType: "node",
  entityUuid,
  expiresAt,
  itemType: "log",
  userUuid
})), {
  withCredentials: true
});
export const removeByUuidAtDate = (axios, entityUuid, date) => axios.post("/items/delete", {
  entityUuids: [entityUuid]
}, {
  params: {
    day: formatDayParameters(date),
    tz: resolveTimezone()
  },
  withCredentials: true
});
export const removeAllAtDate = (axios, date, userUuid) => axios.delete(`/items/${userUuid}`, {
  params: {
    day: formatDayParameters(date),
    tz: resolveTimezone()
  },
  withCredentials: true
});
const resolveTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
const formatDayParameters = date => format(new Date(date), "yyyy-MM-dd");